import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Progress } from "@shadcn-in-nx/ui/progress";
import { toast } from "sonner";

export function FileList({ files, copyToClipboard, renderActions }) {
    if (!files?.length) return null;

    const handleClick = (file) => {
        if (copyToClipboard && file.url) {
            navigator.clipboard.writeText(file.url);
            toast.success("Copied to clipboard");
        }
    };

    return (
        <div className="space-y-2 mt-4">
            {files.map((file) => (
                <div
                    key={file.id}
                    className={`flex items-center gap-2 p-2 bg-slate-50 rounded ${
                        copyToClipboard && file.url
                            ? "cursor-pointer hover:bg-slate-100"
                            : ""
                    }`}
                    onClick={() => handleClick(file)}
                >
                    <div className="flex-1">
                        <p className="text-sm font-medium">{file.name}</p>
                        {file.status === "error" && (
                            <p className="text-xs text-red-500">{file.error}</p>
                        )}
                    </div>

                    <div className="flex items-center gap-2">
                        {file.status === "uploading" && (
                            <>
                                <Loader2 className="h-4 w-4 animate-spin text-slate-500" />
                                <div className="w-24">
                                    <Progress
                                        value={file.progress}
                                        className="h-2"
                                    />
                                </div>
                            </>
                        )}
                        {file.status === "completed" && (
                            <CheckCircle className="h-5 w-5 text-green-500" />
                        )}
                        {file.status === "error" && (
                            <XCircle className="h-5 w-5 text-red-500" />
                        )}
                        {renderActions && renderActions(file)}
                    </div>
                </div>
            ))}
        </div>
    );
}
